import { QueryClient } from '@tanstack/react-query';

// Custom retry logic: retry 503 (server bootstrapping) aggressively,
// but don't retry 4xx client errors (except 503).
function shouldRetry(failureCount: number, error: any): boolean {
  const status = error?.status ?? error?.response?.status;
  if (status === 503) return failureCount < 8; // Retry up to 8x for bootstrap gate (covers 25s window)
  if (status >= 400 && status < 500) return false; // Never retry client errors
  return failureCount < 2; // Default: 2 retries for network/5xx errors
}

function retryDelay(attemptIndex: number, error: any): number {
  const status = error?.status ?? error?.response?.status;
  if (status === 503) return 3000; // Flat 3s for 503 — server says retryAfter:3
  return Math.min(1000 * 2 ** attemptIndex, 10000); // Exponential for others
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: shouldRetry,
      retryDelay,
    },
  },
});
